/************************************
MODULE:         Social buttons
WHAT IT DOES:   initializes all the social/like buttons
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else { root.returnExports = factory(root.jQuery); }
}(this, function ($) {


    function init() {
        var promoBlocks = $('.js-promo').not('.js-promo-inited');
        if (!promoBlocks.length)
            return;

        promoBlocks.addClass('js-promo-inited');

        var genericpromo= require('generic.promo');

        for (var i = 0, l = promoBlocks.length; i < l; i++) {
            new genericpromo(promoBlocks.eq(i));
        }
    }

    return {
        init: init
    }

}));



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.promo.js
 ** module id = 51
 ** module chunks = 24
 **/